import React from 'react';

import AdultIcon from '@icons/adult.svg';
import AirconditioningIcon from '@icons/airconditioning.svg';
import BathTubIcon from '@icons/bath-tub.svg';
import BedIcon from '@icons/bed.svg';
import BreakfastIcon from '@icons/breakfast.svg';
import FacilitiesIcon from '@icons/facilities.svg';
import FridgeIcon from '@icons/fridge.svg';
import NonSmokingIcon from '@icons/non_smoking.svg';
import PetFriendlyIcon from '@icons/pet_friendly.svg';
import ProhibitedIcon from '@icons/prohibited.svg';
import RoomServiceIcon from '@icons/room_service.svg';
import SafeIcon from '@icons/safe.svg';
import ShowerIcon from '@icons/shower.svg';
import SmokingIcon from '@icons/smoking.svg';
import SwimmingPool from '@icons/swimming_pool.svg';
import TickSmallIcon from '@icons/tick_small.svg';
import ToiletBowlIcon from '@icons/toilet-bowl.svg';
import TvIcon from '@icons/tv.svg';
import WifiIcon from '@icons/wifi.svg';
import WindowIcon from '@icons/window.svg';

interface RoomAmenityIconProps {
  roomAmenityId: number;
  className?: string;
  size?: number;
}

const RoomAmenityIcon: React.FC<RoomAmenityIconProps> = ({
  roomAmenityId,
  className,
  size = 24,
}) => {
  const icon: { [key: number]: React.FC<React.SVGAttributes<SVGElement>> | null } = Object.freeze({
    2: AirconditioningIcon, //Air conditioning
    7: BathTubIcon, //Bathtub
    13: null, //Coffee/Tea maker
    27: null, //HairDryer
    32: WifiIcon, //Internet access
    34: null, //Iron & ironing board
    38: null, //Microwave
    49: SwimmingPool, //Private pool
    68: TvIcon, //Television
    79: null, //Dryer
    81: null, //Stove
    82: FridgeIcon, //Refrigerator
    83: null, //Oven
    86: null, //Kitchen
    90: null, //Carbon monoxide detector
    92: null, //Fire extinguisher
    93: BedIcon, //Premium Bedding
    94: BedIcon, //Bed Linen
    95: BedIcon, //Bed Linen (surcharge)
    96: BedIcon, //Hypoallergenic Bed Linen
    97: BedIcon, //Premium Bed linen
    98: null, //Electric blanket
    99: null, //Feather Pillows
    100: null, //Foam Pillows
    101: null, //Hypoallergenic Pillows
    102: null, //Pillow Menu
    103: WindowIcon, //Window
    104: ProhibitedIcon, //No Windows
    105: null, //Separate bedroom
    106: null, //Blackout Curtains
    107: AirconditioningIcon, //Air conditioning (surcharge)
    108: null, //Heating
    109: null, //Fan
    110: SafeIcon, //Safe
    111: SafeIcon, //Safe (surcharge)
    112: BathTubIcon, //Private Bathroom
    113: ShowerIcon, //Partially Open Bathroom
    114: ShowerIcon, //Outdoor Bathroom
    115: ShowerIcon, //Private bathroom (not in room)
    116: BathTubIcon, //Shared Bathroom
    117: null, //Bidet
    118: ToiletBowlIcon, //Toilet
    119: ToiletBowlIcon, //Shared Toilet
    120: ShowerIcon, //Indoor Shower
    121: ShowerIcon, //Outdoor Shower
    122: ShowerIcon, //Walk in shower
    123: BathTubIcon, //Hot Tub
    124: BathTubIcon, //Spa Bathtub
    125: BathTubIcon, //Spring Bath
    126: ShowerIcon, //Separate tub and shower
    127: null, //Sauna
    128: null, //Hairdryer (on request)
    129: ToiletBowlIcon, //Free toiletries
    130: ToiletBowlIcon, //Designer toiletries
    131: null, //Towels provided
    132: null, //Bathrobes provided
    133: null, //Bathrobes (on request)
    134: null, //Slippers provided
    135: null, //Kitchenette
    136: null, //Shared Kitchenette
    137: null, //Dishwasher
    138: null, //Microwave (on request)
    139: null, //Microwave (surcharge)
    140: FridgeIcon, //Refrigerator (on request)
    141: FridgeIcon, //Refrigerator (surcharge)
    142: null, //Minibar
    143: null, //Minibar (free)
    144: null, //Electric Kettle
    145: null, //Coffee maker
    146: BreakfastIcon, // Free Coffee
    147: BreakfastIcon, // Free Tea
    148: null, //Free bottled water
    149: FacilitiesIcon, //Accessible room
    150: FacilitiesIcon, //Accessible bathroom
    151: null, //Roll-in shower
    152: WifiIcon, //Internet access (surcharge)
    153: WifiIcon, //Free WiFi
    154: WifiIcon, //Wifi (surcharge)
    155: TvIcon, //Flat screen TV
    156: TvIcon, //Television (surcharge)
    157: TvIcon, //Premium TV channels
    158: TvIcon, //Satellite TV channels
    159: TvIcon, //Streaming Channels Available
    160: null, //Turndown service
    161: null, //Free local calls
    162: null, //Free long-distance calls
    163: null, //Soundproofed room
    164: null, //Fireplace
    165: null, //Air Purifier
    166: null, //Smoke detector
    167: null, //Private yard
    168: null, //Private patio
    169: null, //Balcony
    170: null, //Terrace
    171: null, //Plunge Pool
    172: null, //Washer-Dryer
    173: null, //Washing machine
    174: null, //Iron & ironing board (on request)
    175: null, //Laundry Services
    176: RoomServiceIcon, //Room service
    177: PetFriendlyIcon, //Pet Friendly
    178: null, //Male only
    179: null, //Female only
    180: AdultIcon, //Adults Only
    181: SmokingIcon, //Smoking allowed
    182: NonSmokingIcon, // Smoking not allowed
    183: null, //Lounge Access
    184: null, //Connecting Rooms Available
    185: null, //Concierge services
  });

  const RoomAmenityIcon = icon[roomAmenityId];

  return RoomAmenityIcon ? (
    <RoomAmenityIcon className={className} width={size} height={size} />
  ) : (
    <TickSmallIcon className={className} width={size} height={size} />
  );
};

export default RoomAmenityIcon;
